module.exports = __webpack_public_path__ + "img/logo-service.8a8c7341.png";